/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_RecommendedInputs */

const cs_billing_plan_recommended = /** @type {(inputs: Billing_Plan_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doporučeno`)
};

const en_billing_plan_recommended = /** @type {(inputs: Billing_Plan_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Billing_Plan_RecommendedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_recommended = /** @type {((inputs?: Billing_Plan_RecommendedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_RecommendedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_recommended(inputs)
	return cs_billing_plan_recommended(inputs)
});